// extracted by mini-css-extract-plugin
module.exports = {"svg":"modal-1-pie-3-module--svg--1se3h"};